
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */
// biome-ignore-all lint: generated file

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  DbNull,
  JsonNull,
  AnyNull,
  NullTypes,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 7.9.0
 * Query Engine version: e922089b7d7502aff4249d5da3420f6fa55fc6ad
 */
Prisma.prismaVersion = {
  client: "7.9.0",
  engine: "e922089b7d7502aff4249d5da3420f6fa55fc6ad"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = DbNull
Prisma.JsonNull = JsonNull
Prisma.AnyNull = AnyNull

Prisma.NullTypes = NullTypes



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ThreadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  title: 'title',
  summary: 'summary',
  contentType: 'contentType',
  contentId: 'contentId',
  archivedAt: 'archivedAt'
};

exports.Prisma.ThreadMessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  content: 'content',
  role: 'role',
  metadata: 'metadata',
  threadId: 'threadId',
  userId: 'userId'
};

exports.Prisma.ChatRateLimitScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  count: 'count',
  resetAt: 'resetAt'
};

exports.Prisma.ExamQuestionScalarFieldEnum = {
  key: 'key',
  courseId: 'courseId',
  questionType: 'questionType',
  difficultyLevel: 'difficultyLevel',
  cognitiveLevel: 'cognitiveLevel',
  tags: 'tags',
  sectionKey: 'sectionKey',
  subSectionKey: 'subSectionKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hash: 'hash'
};

exports.Prisma.GeneratedExamScalarFieldEnum = {
  id: 'id',
  status: 'status',
  errorMessage: 'errorMessage',
  courseId: 'courseId',
  inputSnapshot: 'inputSnapshot',
  inputHash: 'inputHash',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GenerateExamSectionScalarFieldEnum = {
  id: 'id',
  sectionKey: 'sectionKey',
  subSectionKey: 'subSectionKey',
  errorMessage: 'errorMessage',
  isRegenerating: 'isRegenerating',
  regenerationFeedback: 'regenerationFeedback',
  parentId: 'parentId',
  examId: 'examId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GeneratedExamQuestionScalarFieldEnum = {
  id: 'id',
  isAccepted: 'isAccepted',
  isRegenerating: 'isRegenerating',
  regenerationFeedback: 'regenerationFeedback',
  category: 'category',
  sectionId: 'sectionId',
  sectionIndex: 'sectionIndex',
  questionType: 'questionType',
  difficultyLevel: 'difficultyLevel',
  cognitiveLevel: 'cognitiveLevel',
  tags: 'tags',
  stem: 'stem',
  answer: 'answer',
  distractors: 'distractors',
  rationale: 'rationale',
  multiLogicExplanation: 'multiLogicExplanation',
  childId: 'childId',
  examId: 'examId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.KnowledgeNodeScalarFieldEnum = {
  id: 'id',
  type: 'type',
  sourceId: 'sourceId',
  anchorKey: 'anchorKey',
  parentId: 'parentId',
  orderIndex: 'orderIndex',
  title: 'title',
  slug: 'slug',
  normalizedTitle: 'normalizedTitle',
  aliases: 'aliases',
  access: 'access',
  contentHash: 'contentHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.KnowledgeLayerScalarFieldEnum = {
  id: 'id',
  nodeId: 'nodeId',
  level: 'level',
  status: 'status',
  text: 'text',
  tokenCount: 'tokenCount',
  sourceHash: 'sourceHash',
  requestKey: 'requestKey',
  batchJobName: 'batchJobName',
  attempts: 'attempts',
  errorMessage: 'errorMessage',
  promptVersion: 'promptVersion',
  model: 'model',
  builtAt: 'builtAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.KnowledgeEdgeScalarFieldEnum = {
  id: 'id',
  fromId: 'fromId',
  toId: 'toId',
  type: 'type',
  confidence: 'confidence',
  weight: 'weight',
  source: 'source',
  reviewedAt: 'reviewedAt',
  createdAt: 'createdAt'
};

exports.Prisma.LearnerEvidenceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  source: 'source',
  sourceId: 'sourceId',
  outcome: 'outcome',
  documentId: 'documentId',
  sectionKey: 'sectionKey',
  conceptId: 'conceptId',
  conceptTitle: 'conceptTitle',
  questionKey: 'questionKey',
  cognitiveLevel: 'cognitiveLevel',
  difficultyLevel: 'difficultyLevel',
  reason: 'reason',
  occurredAt: 'occurredAt',
  createdAt: 'createdAt'
};

exports.Prisma.LearnerConceptScalarFieldEnum = {
  userId: 'userId',
  conceptId: 'conceptId',
  strength: 'strength',
  peak: 'peak',
  confidence: 'confidence',
  sessionCount: 'sessionCount',
  evidenceCount: 'evidenceCount',
  hasGradedEvidence: 'hasGradedEvidence',
  lastEvidenceAt: 'lastEvidenceAt',
  resetAt: 'resetAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProgramScalarFieldEnum = {
  id: 'id',
  name: 'name',
  goal: 'goal',
  type: 'type',
  status: 'status',
  isArchived: 'isArchived',
  isEditorial: 'isEditorial',
  contentType: 'contentType',
  contentId: 'contentId',
  version: 'version',
  userId: 'userId',
  duplicatedFromId: 'duplicatedFromId',
  buildDuration: 'buildDuration',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  inputSnapshot: 'inputSnapshot',
  inputHash: 'inputHash',
  directoryId: 'directoryId'
};

exports.Prisma.ProgramDirectoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isArchived: 'isArchived',
  userId: 'userId',
  parentDirectoryId: 'parentDirectoryId'
};

exports.Prisma.ProgramStrengthTrainingScalarFieldEnum = {
  id: 'id',
  experience: 'experience',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  programId: 'programId'
};

exports.Prisma.ProgramStrengthTrainingPhaseScalarFieldEnum = {
  id: 'id',
  name: 'name',
  orderIndex: 'orderIndex',
  acuteVariablesId: 'acuteVariablesId',
  warmupRoutineId: 'warmupRoutineId',
  lowerWarmupRoutineId: 'lowerWarmupRoutineId',
  upperWarmupRoutineId: 'upperWarmupRoutineId',
  mainRoutineId: 'mainRoutineId',
  undulationRoutineId: 'undulationRoutineId',
  strengthTrainingProgramId: 'strengthTrainingProgramId'
};

exports.Prisma.ProgramClinicalScalarFieldEnum = {
  id: 'id',
  type: 'type',
  commonComplaints: 'commonComplaints',
  mobilityRoutineId: 'mobilityRoutineId',
  activationIntegrationRoutineId: 'activationIntegrationRoutineId',
  homeExerciseRoutineId: 'homeExerciseRoutineId',
  programId: 'programId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProgramClinicalHypothesizedChangesScalarFieldEnum = {
  id: 'id',
  treatmentSummary: 'treatmentSummary',
  laterality: 'laterality',
  overactiveShort: 'overactiveShort',
  overactiveLong: 'overactiveLong',
  underactiveLong: 'underactiveLong',
  underactiveShort: 'underactiveShort',
  stiffJoints: 'stiffJoints',
  clinicalProgramId: 'clinicalProgramId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProgramRoutineScalarFieldEnum = {
  id: 'id',
  acuteVariablesId: 'acuteVariablesId',
  movementDysfunctionFocus: 'movementDysfunctionFocus',
  splitType: 'splitType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProgramExerciseScalarFieldEnum = {
  orderIndex: 'orderIndex',
  id: 'id',
  progressionExerciseId: 'progressionExerciseId',
  progressionNotes: 'progressionNotes',
  laterality: 'laterality',
  routineType: 'routineType',
  exerciseId: 'exerciseId',
  isCustom: 'isCustom',
  customData: 'customData',
  isActiveRest: 'isActiveRest',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isArchived: 'isArchived',
  isRegenerating: 'isRegenerating',
  routineId: 'routineId'
};

exports.Prisma.ProgramWorkoutScalarFieldEnum = {
  id: 'id',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  notes: 'notes',
  weightUnit: 'weightUnit',
  programId: 'programId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isArchived: 'isArchived'
};

exports.Prisma.ProgramWorkoutExerciseScalarFieldEnum = {
  id: 'id',
  orderIndex: 'orderIndex',
  laterality: 'laterality',
  exerciseId: 'exerciseId',
  isCustom: 'isCustom',
  customData: 'customData',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workoutId: 'workoutId',
  isCompleted: 'isCompleted'
};

exports.Prisma.ProgramWorkoutExerciseSetScalarFieldEnum = {
  id: 'id',
  reps: 'reps',
  load: 'load',
  rpe: 'rpe',
  toFailure: 'toFailure',
  isDropSet: 'isDropSet',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workoutExerciseId: 'workoutExerciseId'
};

exports.Prisma.ProgramAcuteVariablesScalarFieldEnum = {
  id: 'id',
  minCycleLength: 'minCycleLength',
  maxCycleLength: 'maxCycleLength',
  minFrequency: 'minFrequency',
  maxFrequency: 'maxFrequency',
  minTrainingTime: 'minTrainingTime',
  maxTrainingTime: 'maxTrainingTime',
  minLoad: 'minLoad',
  maxLoad: 'maxLoad',
  minReps: 'minReps',
  maxReps: 'maxReps',
  repsToFailure: 'repsToFailure',
  loadingStyle: 'loadingStyle',
  minSets: 'minSets',
  maxSets: 'maxSets',
  restBetweenSets: 'restBetweenSets',
  minCircuits: 'minCircuits',
  maxCircuits: 'maxCircuits',
  restBetweenExercises: 'restBetweenExercises',
  restBetweenCircuits: 'restBetweenCircuits',
  tempoEccentric: 'tempoEccentric',
  tempoIsometric: 'tempoIsometric',
  tempoConcentric: 'tempoConcentric',
  setStrategy: 'setStrategy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProgramInvitationScalarFieldEnum = {
  id: 'id',
  emailAddress: 'emailAddress',
  userId: 'userId',
  programId: 'programId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudyRecommendationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  courseId: 'courseId',
  kind: 'kind',
  sectionKey: 'sectionKey',
  subSectionKey: 'subSectionKey',
  rationale: 'rationale',
  priority: 'priority',
  status: 'status',
  sourceThreadId: 'sourceThreadId'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  adminId: 'adminId',
  maxAllowedMemberships: 'maxAllowedMemberships',
  stripeCustomerId: 'stripeCustomerId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  initialFirstName: 'initialFirstName',
  initialLastName: 'initialLastName',
  firstName: 'firstName',
  lastName: 'lastName',
  username: 'username',
  primaryEmailAddress: 'primaryEmailAddress',
  primaryPhoneNumber: 'primaryPhoneNumber',
  smsPhoneNumber: 'smsPhoneNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  signUpPath: 'signUpPath',
  organizationId: 'organizationId',
  primaryProfessionId: 'primaryProfessionId',
  secondaryProfessionId: 'secondaryProfessionId',
  selectedCertificationId: 'selectedCertificationId',
  title: 'title',
  bio: 'bio',
  interests: 'interests',
  isOnboardingCompleted: 'isOnboardingCompleted',
  linkedInUrl: 'linkedInUrl',
  instagramUrl: 'instagramUrl',
  city: 'city',
  country: 'country',
  countryCode: 'countryCode',
  ipAddress: 'ipAddress',
  timezone: 'timezone',
  customLocation: 'customLocation',
  braintreeCustomerId: 'braintreeCustomerId',
  stripeCustomerId: 'stripeCustomerId',
  stripeConnectId: 'stripeConnectId',
  externalId: 'externalId',
  cataMemberNumber: 'cataMemberNumber',
  gender: 'gender',
  signupSource: 'signupSource',
  userIntent: 'userIntent',
  dateOfBirth: 'dateOfBirth',
  employerName: 'employerName'
};

exports.Prisma.UserPreferencesScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  isPublic: 'isPublic',
  isOpenToJobs: 'isOpenToJobs',
  isOpenToOnlineSessions: 'isOpenToOnlineSessions',
  isOpenToClients: 'isOpenToClients',
  isOpenToNetworking: 'isOpenToNetworking'
};

exports.Prisma.WorkExperienceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  title: 'title',
  companyName: 'companyName',
  startedAt: 'startedAt',
  location: 'location',
  workload: 'workload',
  endedAt: 'endedAt',
  description: 'description',
  companyUrl: 'companyUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EducationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  degree: 'degree',
  fieldOfStudy: 'fieldOfStudy',
  schoolName: 'schoolName',
  location: 'location',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ReferralScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  referrerId: 'referrerId',
  refereeId: 'refereeId',
  userId: 'userId'
};

exports.Prisma.CashScalarFieldEnum = {
  id: 'id',
  chargeId: 'chargeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  referralId: 'referralId',
  amount: 'amount',
  description: 'description',
  isPaidOut: 'isPaidOut'
};

exports.Prisma.InvitationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  emailAddress: 'emailAddress',
  inviterId: 'inviterId',
  inviteeId: 'inviteeId'
};

exports.Prisma.FeedbackScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  rating: 'rating',
  path: 'path',
  body: 'body'
};

exports.Prisma.AuditedCourseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  courseId: 'courseId',
  userId: 'userId'
};

exports.Prisma.AuditedVideoScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  videoId: 'videoId',
  userId: 'userId'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  status: 'status',
  userId: 'userId',
  organizationId: 'organizationId',
  planType: 'planType',
  paymentProvider: 'paymentProvider',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  isPaused: 'isPaused'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  status: 'status',
  level: 'level',
  content: 'content',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  channel: 'channel'
};

exports.Prisma.WebPushSubscriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  userId: 'userId',
  endpoint: 'endpoint',
  auth: 'auth',
  p256dh: 'p256dh'
};

exports.Prisma.LikeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  contentType: 'contentType',
  contentId: 'contentId'
};

exports.Prisma.HistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  contentType: 'contentType',
  contentId: 'contentId'
};

exports.Prisma.HighlightScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contentType: 'contentType',
  contentId: 'contentId',
  userId: 'userId',
  startOffset: 'startOffset',
  endOffset: 'endOffset',
  text: 'text',
  color: 'color'
};

exports.Prisma.NoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  contentType: 'contentType',
  contentId: 'contentId',
  highlightId: 'highlightId',
  body: 'body'
};

exports.Prisma.CommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  body: 'body',
  userId: 'userId',
  contentType: 'contentType',
  contentId: 'contentId',
  replyToId: 'replyToId',
  isDeleted: 'isDeleted'
};

exports.Prisma.CourseProgressScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  courseId: 'courseId',
  sectionKey: 'sectionKey'
};

exports.Prisma.ExamAttemptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  courseId: 'courseId',
  certificationId: 'certificationId',
  examType: 'examType',
  isPassed: 'isPassed',
  expiresAt: 'expiresAt',
  userId: 'userId'
};

exports.Prisma.ExamAttemptQuestionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  examAttemptId: 'examAttemptId',
  questionKey: 'questionKey',
  selectedOptionHash: 'selectedOptionHash',
  correctOptionHash: 'correctOptionHash',
  isCorrect: 'isCorrect',
  userId: 'userId'
};

exports.Prisma.ExamAttemptSummaryScalarFieldEnum = {
  id: 'id',
  status: 'status',
  examAttemptId: 'examAttemptId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  internalAnalysis: 'internalAnalysis',
  attemptAnalysis: 'attemptAnalysis',
  studyRecommendation: 'studyRecommendation',
  focusSections: 'focusSections',
  actionIntent: 'actionIntent',
  userId: 'userId'
};

exports.Prisma.NccaExamCoachSummaryScalarFieldEnum = {
  id: 'id',
  status: 'status',
  examAttemptId: 'examAttemptId',
  certificationId: 'certificationId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  attemptAnalysis: 'attemptAnalysis',
  focusCourses: 'focusCourses'
};

exports.Prisma.PassedCourseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  courseId: 'courseId',
  userId: 'userId'
};

exports.Prisma.PassedCertificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  certificationId: 'certificationId',
  userId: 'userId',
  expiresAt: 'expiresAt',
  isCandidate: 'isCandidate'
};

exports.Prisma.SpecialCreditsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  certificationId: 'certificationId',
  userId: 'userId',
  credits: 'credits',
  note: 'note'
};

exports.Prisma.ExamSurveyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  surveyId: 'surveyId',
  courseId: 'courseId',
  answer: 'answer'
};

exports.Prisma.PurchasedWorkshopScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  isApproved: 'isApproved',
  workshopKey: 'workshopKey',
  workshopTypeId: 'workshopTypeId'
};

exports.Prisma.RegisteredWebinarScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  webinarId: 'webinarId'
};

exports.Prisma.UnsubscribedEmailUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  unsubscribeSource: 'unsubscribeSource',
  unsubscribeReason: 'unsubscribeReason'
};

exports.Prisma.BookmarkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  contentType: 'contentType',
  contentId: 'contentId'
};

exports.Prisma.SurveyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  surveyId: 'surveyId',
  surveyData: 'surveyData'
};

exports.Prisma.EmailAnalyticsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  data: 'data'
};

exports.Prisma.QuizScalarFieldEnum = {
  id: 'id',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  status: 'status'
};

exports.Prisma.QuizQuestionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  quizId: 'quizId',
  stem: 'stem',
  distractors: 'distractors',
  answer: 'answer',
  rationale: 'rationale',
  documentId: 'documentId',
  sectionKey: 'sectionKey'
};

exports.Prisma.QuizAttemptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  score: 'score',
  quizId: 'quizId',
  userId: 'userId'
};

exports.Prisma.QuizAttemptQuestionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  quizAttemptId: 'quizAttemptId',
  quizQuestionId: 'quizQuestionId',
  selectedOption: 'selectedOption',
  isCorrect: 'isCorrect',
  userId: 'userId'
};

exports.Prisma.CancellationSurveyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subscriptionId: 'subscriptionId',
  userId: 'userId',
  reason: 'reason',
  otherReason: 'otherReason',
  satisfactionRating: 'satisfactionRating',
  reconsiderationReason: 'reconsiderationReason',
  additionalFeedback: 'additionalFeedback',
  pauseLength: 'pauseLength'
};

exports.Prisma.ExamVoucherScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  legalFirstName: 'legalFirstName',
  legalLastName: 'legalLastName',
  emailAddress: 'emailAddress',
  dateOfBirth: 'dateOfBirth',
  code: 'code'
};

exports.Prisma.PassedAccreditedCertificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  certificationId: 'certificationId',
  passedAt: 'passedAt',
  expiresAt: 'expiresAt',
  voucherId: 'voucherId',
  userId: 'userId'
};

exports.Prisma.GiftCardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  subscriptionId: 'subscriptionId',
  amount: 'amount',
  claimCode: 'claimCode'
};

exports.Prisma.UserCeuGoalScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  accreditationId: 'accreditationId',
  targetCredits: 'targetCredits',
  renewalDate: 'renewalDate'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.ContentType = exports.$Enums.ContentType = {
  ARTICLE: 'ARTICLE',
  VIDEO: 'VIDEO',
  COURSE: 'COURSE',
  GLOSSARY: 'GLOSSARY',
  WEBINAR: 'WEBINAR',
  WORKSHOP: 'WORKSHOP',
  CERTIFICATION: 'CERTIFICATION'
};

exports.ThreadMessageRole = exports.$Enums.ThreadMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT'
};

exports.QuestionType = exports.$Enums.QuestionType = {
  standard_mcq: 'standard_mcq',
  multi_logic_mcq: 'multi_logic_mcq'
};

exports.DifficultyLevel = exports.$Enums.DifficultyLevel = {
  easy: 'easy',
  medium: 'medium',
  hard: 'hard'
};

exports.CognitiveLevel = exports.$Enums.CognitiveLevel = {
  recall: 'recall',
  comprehension: 'comprehension',
  application: 'application',
  analysis: 'analysis',
  evaluate: 'evaluate',
  synthesis: 'synthesis'
};

exports.ExamGenerationStatus = exports.$Enums.ExamGenerationStatus = {
  pending: 'pending',
  processing: 'processing',
  draft: 'draft',
  active: 'active',
  failed: 'failed'
};

exports.ExamCategory = exports.$Enums.ExamCategory = {
  practice: 'practice',
  final: 'final',
  bank: 'bank'
};

exports.KnowledgeNodeType = exports.$Enums.KnowledgeNodeType = {
  course: 'course',
  section: 'section',
  article: 'article',
  video: 'video',
  glossary: 'glossary',
  concept: 'concept'
};

exports.KnowledgeLevel = exports.$Enums.KnowledgeLevel = {
  L0: 'L0',
  L1: 'L1',
  L2: 'L2',
  L3: 'L3'
};

exports.KnowledgeLayerStatus = exports.$Enums.KnowledgeLayerStatus = {
  stale: 'stale',
  queued: 'queued',
  submitted: 'submitted',
  ready: 'ready',
  failed: 'failed'
};

exports.KnowledgeEdgeType = exports.$Enums.KnowledgeEdgeType = {
  TEACHES: 'TEACHES',
  ASSUMES: 'ASSUMES',
  RELATED: 'RELATED'
};

exports.KnowledgeEdgeSource = exports.$Enums.KnowledgeEdgeSource = {
  curated: 'curated',
  derived: 'derived',
  extracted: 'extracted'
};

exports.LearnerEvidenceSource = exports.$Enums.LearnerEvidenceSource = {
  EXAM_ANSWER: 'EXAM_ANSWER',
  QUIZ_ANSWER: 'QUIZ_ANSWER',
  TUTOR_OBSERVATION: 'TUTOR_OBSERVATION',
  EXPOSURE: 'EXPOSURE'
};

exports.LearnerEvidenceOutcome = exports.$Enums.LearnerEvidenceOutcome = {
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
  DEMONSTRATED: 'DEMONSTRATED',
  STRUGGLED: 'STRUGGLED',
  EXPOSED: 'EXPOSED'
};

exports.ProgramType = exports.$Enums.ProgramType = {
  strength_training: 'strength_training',
  clinical: 'clinical'
};

exports.ProgramStatus = exports.$Enums.ProgramStatus = {
  pending: 'pending',
  pending_regeneration: 'pending_regeneration',
  processing: 'processing',
  regenerating: 'regenerating',
  failed: 'failed',
  failed_regeneration: 'failed_regeneration',
  active: 'active'
};

exports.ExperienceLevel = exports.$Enums.ExperienceLevel = {
  beginner: 'beginner',
  intermediate: 'intermediate',
  advanced: 'advanced'
};

exports.ClinicalProgramType = exports.$Enums.ClinicalProgramType = {
  corrective_exercise: 'corrective_exercise',
  manual_therapy: 'manual_therapy'
};

exports.Laterality = exports.$Enums.Laterality = {
  bilateral: 'bilateral',
  right: 'right',
  left: 'left'
};

exports.SplitType = exports.$Enums.SplitType = {
  full_body: 'full_body',
  upper_lower: 'upper_lower',
  push_pull_legs: 'push_pull_legs'
};

exports.RoutineType = exports.$Enums.RoutineType = {
  full_body: 'full_body',
  upper: 'upper',
  lower: 'lower',
  push: 'push',
  pull: 'pull',
  legs: 'legs'
};

exports.WeightUnit = exports.$Enums.WeightUnit = {
  kg: 'kg',
  lb: 'lb'
};

exports.LoadingStyle = exports.$Enums.LoadingStyle = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};

exports.SetStrategy = exports.$Enums.SetStrategy = {
  standard: 'standard',
  drop_sets: 'drop_sets',
  strength_stability_dropsets: 'strength_stability_dropsets',
  pap: 'pap'
};

exports.InvitationStatus = exports.$Enums.InvitationStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  REVOKED: 'REVOKED'
};

exports.StudyRecommendationKind = exports.$Enums.StudyRecommendationKind = {
  SECTION: 'SECTION',
  COURSE: 'COURSE'
};

exports.StudyRecommendationStatus = exports.$Enums.StudyRecommendationStatus = {
  ACTIVE: 'ACTIVE',
  SUPERSEDED: 'SUPERSEDED'
};

exports.Gender = exports.$Enums.Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER'
};

exports.SignupSource = exports.$Enums.SignupSource = {
  WORD_OF_MOUTH: 'WORD_OF_MOUTH',
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  TWITTER_X: 'TWITTER_X',
  LINKEDIN: 'LINKEDIN',
  REDDIT: 'REDDIT',
  SEARCH_ENGINE: 'SEARCH_ENGINE',
  EMAIL_CAMPAIGN: 'EMAIL_CAMPAIGN',
  YOUTUBE_VIDEO: 'YOUTUBE_VIDEO',
  PODCAST: 'PODCAST',
  PARTNERSHIP: 'PARTNERSHIP',
  OTHER: 'OTHER'
};

exports.UserIntent = exports.$Enums.UserIntent = {
  EARN_CERTIFICATION: 'EARN_CERTIFICATION',
  CONTINUING_EDUCATION_CREDITS: 'CONTINUING_EDUCATION_CREDITS',
  SKILL_DEVELOPMENT: 'SKILL_DEVELOPMENT',
  EMPLOYER_SPONSORED: 'EMPLOYER_SPONSORED',
  SCHOOL_SPONSORED: 'SCHOOL_SPONSORED',
  EXPLORING_PLATFORM: 'EXPLORING_PLATFORM',
  OTHER: 'OTHER'
};

exports.Workload = exports.$Enums.Workload = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME'
};

exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELED: 'CANCELED',
  UNPAID: 'UNPAID',
  INCOMPLETE: 'INCOMPLETE',
  INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
  TRIALING: 'TRIALING',
  EXPIRED: 'EXPIRED',
  PENDING: 'PENDING'
};

exports.PlanType = exports.$Enums.PlanType = {
  INDIVIDUAL: 'INDIVIDUAL',
  TEAM: 'TEAM'
};

exports.PaymentProvider = exports.$Enums.PaymentProvider = {
  STRIPE: 'STRIPE',
  BRAINTREE: 'BRAINTREE',
  PAYPAL: 'PAYPAL'
};

exports.NotificationStatus = exports.$Enums.NotificationStatus = {
  UNREAD: 'UNREAD',
  READ: 'READ',
  DELETED: 'DELETED',
  CLICKED: 'CLICKED'
};

exports.NotificationLevel = exports.$Enums.NotificationLevel = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR'
};

exports.NotificationChannel = exports.$Enums.NotificationChannel = {
  SITE: 'SITE',
  WEB_PUSH: 'WEB_PUSH'
};

exports.WebPushSubscriptionStatus = exports.$Enums.WebPushSubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

exports.Color = exports.$Enums.Color = {
  GREEN: 'GREEN',
  YELLOW: 'YELLOW',
  RED: 'RED'
};

exports.ExamType = exports.$Enums.ExamType = {
  FINAL: 'FINAL',
  PRACTICE: 'PRACTICE',
  NCCA_PRACTICE: 'NCCA_PRACTICE'
};

exports.GenerationStatus = exports.$Enums.GenerationStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed'
};

exports.ExamAttemptSummaryAction = exports.$Enums.ExamAttemptSummaryAction = {
  STUDY_MORE: 'STUDY_MORE',
  TAKE_FINAL: 'TAKE_FINAL',
  WAIT_AND_STUDY: 'WAIT_AND_STUDY',
  NEXT_COURSE: 'NEXT_COURSE'
};

exports.ResendEventType = exports.$Enums.ResendEventType = {
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  COMPLAINED: 'COMPLAINED',
  BOUNCED: 'BOUNCED',
  OPENED: 'OPENED',
  CLICKED: 'CLICKED',
  DELIVERY_DELAYED: 'DELIVERY_DELAYED'
};

exports.QuizStatus = exports.$Enums.QuizStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED'
};

exports.CancellationReason = exports.$Enums.CancellationReason = {
  TOO_EXPENSIVE: 'TOO_EXPENSIVE',
  LACK_OF_TIME: 'LACK_OF_TIME',
  CERTIFICATION_COMPLETED: 'CERTIFICATION_COMPLETED',
  CEC_COMPLETED: 'CEC_COMPLETED',
  FOUND_ALTERNATIVE: 'FOUND_ALTERNATIVE',
  TECHNICAL_ISSUES: 'TECHNICAL_ISSUES',
  HARD_TO_NAVIGATE: 'HARD_TO_NAVIGATE',
  OTHER: 'OTHER'
};

exports.Prisma.ModelName = {
  Thread: 'Thread',
  ThreadMessage: 'ThreadMessage',
  ChatRateLimit: 'ChatRateLimit',
  ExamQuestion: 'ExamQuestion',
  GeneratedExam: 'GeneratedExam',
  GenerateExamSection: 'GenerateExamSection',
  GeneratedExamQuestion: 'GeneratedExamQuestion',
  KnowledgeNode: 'KnowledgeNode',
  KnowledgeLayer: 'KnowledgeLayer',
  KnowledgeEdge: 'KnowledgeEdge',
  LearnerEvidence: 'LearnerEvidence',
  LearnerConcept: 'LearnerConcept',
  Program: 'Program',
  ProgramDirectory: 'ProgramDirectory',
  ProgramStrengthTraining: 'ProgramStrengthTraining',
  ProgramStrengthTrainingPhase: 'ProgramStrengthTrainingPhase',
  ProgramClinical: 'ProgramClinical',
  ProgramClinicalHypothesizedChanges: 'ProgramClinicalHypothesizedChanges',
  ProgramRoutine: 'ProgramRoutine',
  ProgramExercise: 'ProgramExercise',
  ProgramWorkout: 'ProgramWorkout',
  ProgramWorkoutExercise: 'ProgramWorkoutExercise',
  ProgramWorkoutExerciseSet: 'ProgramWorkoutExerciseSet',
  ProgramAcuteVariables: 'ProgramAcuteVariables',
  ProgramInvitation: 'ProgramInvitation',
  StudyRecommendation: 'StudyRecommendation',
  Organization: 'Organization',
  User: 'User',
  UserPreferences: 'UserPreferences',
  WorkExperience: 'WorkExperience',
  Education: 'Education',
  Referral: 'Referral',
  Cash: 'Cash',
  Invitation: 'Invitation',
  Feedback: 'Feedback',
  AuditedCourse: 'AuditedCourse',
  AuditedVideo: 'AuditedVideo',
  Subscription: 'Subscription',
  Notification: 'Notification',
  WebPushSubscription: 'WebPushSubscription',
  Like: 'Like',
  History: 'History',
  Highlight: 'Highlight',
  Note: 'Note',
  Comment: 'Comment',
  CourseProgress: 'CourseProgress',
  ExamAttempt: 'ExamAttempt',
  ExamAttemptQuestion: 'ExamAttemptQuestion',
  ExamAttemptSummary: 'ExamAttemptSummary',
  NccaExamCoachSummary: 'NccaExamCoachSummary',
  PassedCourse: 'PassedCourse',
  PassedCertification: 'PassedCertification',
  SpecialCredits: 'SpecialCredits',
  ExamSurvey: 'ExamSurvey',
  PurchasedWorkshop: 'PurchasedWorkshop',
  RegisteredWebinar: 'RegisteredWebinar',
  UnsubscribedEmailUser: 'UnsubscribedEmailUser',
  Bookmark: 'Bookmark',
  Survey: 'Survey',
  EmailAnalytics: 'EmailAnalytics',
  Quiz: 'Quiz',
  QuizQuestion: 'QuizQuestion',
  QuizAttempt: 'QuizAttempt',
  QuizAttemptQuestion: 'QuizAttemptQuestion',
  CancellationSurvey: 'CancellationSurvey',
  ExamVoucher: 'ExamVoucher',
  PassedAccreditedCertification: 'PassedAccreditedCertification',
  GiftCard: 'GiftCard',
  UserCeuGoal: 'UserCeuGoal'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
